<template>
    <div>
        <v-row class="mb-0 d-flex">
            <v-col cols="6" :sm="10" class="mb-0 pb-0">
                <v-text-field
                    v-model="searchText"
                    class="search"
                    :label="$t('backoffice.components.search.title')"
                    prepend-inner-icon="mdi-magnify"
                    @keypress.enter="searchForm"
                    @blur="searchForm"
                >
                </v-text-field>
            </v-col>
            <v-col cols="12" class="mb-0 pb-0 pt-0">
                <hr class="mb-0 mt-0">
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {

    data() {
        return {
            searchState: false,
            searchText: '',
        }
    },

    methods:{

        openSearchAdvanced(){
            this.searchState = !this.searchState
        },

        searchForm() {
            this.$emit('on-search-garage', this.searchText);
        },
    },
}
</script>

<style lang="scss">
    .row-search{
        &::before{
            content:' ';
            height: 1px;
            width: 100%;
            position: absolute;
            background-color: #D6D6D6;
            bottom: 0;
            left: 0;
        }
    }
    .search{
        .v-input__control{
            .v-input__slot{
                margin-bottom: 0px !important;
                &::before{
                    border: 0 !important;
                }
                label{
                    font-size: 12px;
                    color: #9E9D9D;
                }
            }
        }
        .v-text-field__details{
            min-height: 0px;
            display: none;
        }
    }

    .buttonAdvanced{
        font-size: 12px !important;
        text-transform: capitalize !important;
        color: #9E9D9D !important;

        &:hover{
            color: var(--v-primary-base)!important;
            path{
                fill:var(--v-primary-base);
            }
            &:before{
                background-color: transparent !important;
            }
        }
        &:focus{
            &:before{
                background-color: transparent !important;
            }
        }
        &.active{
            color: var(--v-primary-base)!important;
            path{
                fill:var(--v-primary-base);
            }
        }

    }

    .filter-advenced{
        .v-subheader{
            font-size: 12px;
            color:#9E9D9D;
        }
        .v-select__selection{
            font-size:12px;
        }
        .v-input__slot{
            font-size: 12px;
            label{
                font-size: 12px;
            }
        }
    }

</style>
